import { AreasManager } from 'components/Pages/Areas';
import { SettingsMenu } from 'components/Shared';
import { Scaffold } from 'layouts';
import React from 'react';
import * as S from './styles';

export const AreasListPage: React.FC = () => (
  <Scaffold>
    <SettingsMenu />
    <S.PageContainer>
      <AreasManager />
    </S.PageContainer>
  </Scaffold>
);
